"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMap = void 0;
exports.isMap = (value) => value instanceof Map;
//# sourceMappingURL=is-map.js.map